import { Record } from 'immutable';

export const ENTITLEMENTS_REDUCER_KEY = 'entitlementsStore';

export const mkEntitlement = Record({
  id: undefined,
  expiresAt: undefined,
  partnerExpireAt: undefined,
  expiresOn: undefined,
  checkAlertsUntil: undefined,
  active: undefined,
});
